<template>
  <div class="LeaseList">
    <!-- 详情团队业绩  只读 -->
    <ul class="list resultsDetails" v-if="isType == '0'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li v-for="(list, index) in teamList" :key="index">
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.projectName"
            placement="bottom"
            :offset="10"
          >
            <div
              @click="goDeatilRes(list)"
              class="describe"
              style="color: rgb(2, 134, 223) !important;cursor: pointer;display: block"
            >
              {{ list.projectName }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="addressStringOne(list)"
            placement="bottom"
            :offset="10"
          >
            <div class="describe" style="display: inline">
              {{ addressStringOne(list) }}
            </div>
          </el-tooltip>
        </div>
        <!-- <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow='false'
            :content='list.owner'
            placement="bottom"
            :offset='10'
          >
            <div
              class="describe"
              style="display: inline"
            >{{list.owner}}</div>

          </el-tooltip>
        </div> -->
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="changPecTime(list.startTime, list.endTime)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">
              {{ timeToString(list.startTime) }}~{{
                timeToString(list.endTime)
              }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.projectDescribe"
            placement="bottom"
            :offset="1"
          >
            <div class="describe">{{ list.projectDescribe }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.construction"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.construction }}</div>
          </el-tooltip>
        </div>
        <!-- <div class="listDiv">

          <div
            class="ImgBox"
            v-if="list.picturePic&&list.picturePic[0]"
          >
            <el-image
              v-if="list.picturePic"
              style="width: 100px; height: 100px"
              fit="cover"
              :src="list.picturePic&&list.picturePic[0]?list.picturePic[0]:null"
              :preview-src-list="list.picturePic"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>

            <span
              class="picText"
              v-if="list.pictureTotal"
            >共{{list.pictureTotal?list.pictureTotal:0}}条信息</span>
          </div>
          <div
            class="ImgBox"
            v-else-if="list.pictureVideo&&list.pictureVideo[0]"
          >
            <video
              v-if="!list.picturePic&&!list.picturePic[0]&&list.pictureVideo&&list.pictureVideo[0]"
              style="width:100px;height:100px"
              :src="list.pictureVideo[0]"
              class="avatar"
              controls="controls"
            >您的浏览器不支持视频播放
            </video>
            <span
              class="picText"
              v-if="list.pictureTotal"
            >共{{list.pictureTotal?list.pictureTotal:0}}条信息</span>
          </div>

        </div> -->
      </li>
    </ul>
    <!-- 详情人员组成 只读-->
    <ul class="list resultsDetailsPerson" v-else-if="isType == '1'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>

      <li v-for="(list, index) in teamList" :key="index">
        <div class="listDiv">{{ list.name }}</div>
        <div class="listDiv">{{ list.age }}</div>
        <div class="listDiv">{{ list.workingYear }}</div>
        <div class="listDiv">{{ list.contactPhone }}</div>
        <!-- <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow='false'
            :content='list.position'
            placement="bottom"
            :offset='10'
          >
            <div class="describe"> {{list.position}}</div>
          </el-tooltip>

        </div> -->
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.introduction"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              <span
                style="white-space: pre-wrap;"
                v-if="list.introduction"
                v-html="list.introduction"
              >
              </span>
              <!-- {{list.introduction}} -->
            </div>
          </el-tooltip>
        </div>
        <!-- <div class="listDiv">
          <div
            class="ImgBox"
            v-if="list.picture[0]&&list.picture"
          >
            <el-image
              style="width: 100px; height: 100px"
              :src="list.picture[0]"
              :preview-src-list="list.picture"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <span class="picText">共{{list.certificates.length}}条信息</span>
          </div>
        </div> -->
      </li>
    </ul>
    <!-- 详情设备信息 只读-->
    <ul class="list resultsDetailsEqu" v-else-if="isType == '2'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li class="content-title" v-for="(list, index) in teamList" :key="index">
        <div class="listDiv ">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.name"
            placement="bottom"
            :offset="10"
          >
            <div
              @click="GoDetailsEqu(list)"
              class="describe"
              style="    color: #0286df !important;"
            >
              <span>
                {{ list.name }}
              </span>
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.describe"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              <span>
                {{ list.describe }}
              </span>
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.model"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.model }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <div class="ImgBox">
            <el-image
              style="width: 100px; height: 100px"
              :src="list.picture[0]"
              :preview-src-list="list.picture"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa; width: 100px; height: 100px;    lineHeight: 100px;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <span class="picText">共{{ list.picture.length }}张图片</span>
          </div>
        </div>
        <!-- <div class="listDiv">
          <div class="ImgBox">
            <el-image
              v-if="list.picturePic&&list.picturePic[0]"
              style="width: 100px; height: 100px"
              :src="list.picturePic&&list.picturePic[0]?list.picturePic[0]:null"
              :preview-src-list="list.picturePic"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;width: 100px; height: 100px;  lineHeight: 100px;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <video
              v-if="!list.picturePic[0]&&list.pictureVideo&&list.pictureVideo[0]"
              style="width:100px;height:100px"
              :src="list.pictureVideo[0]"
              class="avatar"
              controls="controls"
            >您的浏览器不支持视频播放
            </video>
            <span
              class="picText"
              v-if="list.pictureTotal"
            >共{{list.pictureTotal?list.pictureTotal:0}}条信息</span>
          </div>
        </div> -->
      </li>
    </ul>
    <!-- 详情施工报价 只读-->
    <ul class="list resultsDetailsOffer" v-else-if="isType == '3'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>

      <li
        @click="goDeatilPrise(list)"
        v-for="(list, index) in teamList"
        :key="index"
      >
        <!-- <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow='false'
            :content='ChangeString(list)'
            placement="bottom"
            :offset='10'
          >
            <div style="display: inline">{{ChangeString(list)}}</div>
          </el-tooltip>
        </div> -->

        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.firstCategoryName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe" style="    color: #0286df !important;">
              {{ list.firstCategoryName }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.secondCategoryName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.secondCategoryName }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.thirdCategoryName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.thirdCategoryName }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.typeWork"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.typeWork }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.unit"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.unit }}</div>
          </el-tooltip>
        </div>

        <div :class="['listDiv', list.priceStatus == 2 ? null : 'lhString']">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="ifData(list)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline" v-if="list.priceStatus == 2">
              <div class="hasOne">包含辅材：{{ list.material }}</div>
              <div style="height:1px ;borderTop:1px solid #f1f1f1"></div>
              <div>不含辅材</div>
            </div>
            <div style="display: inline" v-else-if="list.priceStatus == 1">
              <span>不含辅材</span>
            </div>
            <div class="hasOne" v-else-if="list.priceStatus == 0">
              <span>包含辅材：{{ list.material }}</span>
            </div>
          </el-tooltip>
        </div>
        <div :class="['listDiv', list.priceStatus == 2 ? null : 'lhString']">
          <div style="display: inline" v-if="list.priceStatus == 2">
            <div>{{ list.priceWithMaterial }}</div>
            <div style="height:1px ;borderTop:1px dashed #f1f1f1"></div>
            <div>{{ list.price }}</div>
          </div>
          <div style="display: inline" v-else-if="list.priceStatus == 1">
            <span>{{ list.price }}</span>
          </div>
          <div style="display: inline" v-else-if="list.priceStatus == 0">
            <span>{{ list.priceWithMaterial }}</span>
          </div>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.equipment"
            placement="bottom"
            :offset="10"
          >
            <div class="describe" style="display: inline">
              {{ list.equipment }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.teamName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe" style="display: inline">
              <!-- {{list.principle}} -->
              {{ list.teamName }}
            </div>
          </el-tooltip>
        </div>
      </li>
    </ul>
    <!-- 列表展示施工报价 只读-->
    <ul
      :class="['resultsDetailsOfferlist', isborder ? 'noBorder' : null]"
      class="resultsDetailsOfferlist"
      v-else-if="isType == '4'"
    >
      <li>
        <div
          class="table-title"
          v-for="(item, index) in titleList"
          :key="index"
        >
          {{ item }}
        </div>
      </li>

      <li
        v-for="(list, index) in teamList"
        :key="index"
        @click="goRentalDetailsPrice(list)"
      >
        <div class="listDiv">
          <!-- 工程分类 -->
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.firstCategoryName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe" style="    color: #0286df !important;">
              {{ list.firstCategoryName
              }}{{ list.secondCategoryName ? "-" + list.secondCategoryName : ""
              }}{{ list.thirdCategoryName ? "-" + list.thirdCategoryName : ""
              }}{{ list.fourCategoryName ? "-" + list.fourCategoryName : "" }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.typeWork"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.typeWork }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.unit"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ list.unit }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv lhString">
          <div class="hasOne" v-if="list.hasMaterial == 0">
            <el-tooltip
              popper-class="changeTootip"
              effect="light"
              :visible-arrow="false"
              :content="ifData(list)"
              placement="bottom"
              :offset="10"
            >
              <div class="hasLine">
                包含辅材：{{ list.priceWithMaterial }} 不含辅材:{{
                  list.principle
                }}
              </div>
            </el-tooltip>
          </div>
          <div class="hasOne" v-if="list.hasMaterial == 1">
            不含辅材:{{ list.principle }}
          </div>

          <div class="hasTwo" v-if="list.hasMaterial == 2">
            <el-tooltip
              popper-class="changeTootip"
              effect="light"
              :visible-arrow="false"
              :content="ifData(list)"
              placement="bottom"
              :offset="10"
            >
              <div class="hasLine">包含辅材：{{ list.priceWithMaterial }}</div>
            </el-tooltip>
            <div>不含辅材:{{ list.principle }}</div>
          </div>
        </div>
        <div class="listDiv lhString">
          <div class="hasOne" v-if="list.priceStatus == 0">
            {{ list.priceWithMaterial }}
          </div>
          <div class="hasOne" v-if="list.priceStatus == 1">
            {{ list.price }}
          </div>

          <div class="hasTwo" v-if="list.priceStatus == 2">
            <div class="hasLine">{{ list.priceWithMaterial }}</div>
            <div>{{ list.price }}</div>
          </div>
        </div>

        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.equipment"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              <!-- {{list.teamName}} -->
              {{ list.equipment }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.teamName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              {{ list.teamName }}
              <!-- {{list.principle}} -->
            </div>
          </el-tooltip>
        </div>
      </li>
    </ul>

    <!--服务中心 我的团队 操作-->
    <ul class="list my" v-else-if="isType == 'my'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li v-for="(list, index) in teamList" :key="index">
        <div class="listDiv" @click="goTeamDetails(list.no)">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.teamName"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ list.teamName }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="ChangeToString(list.businessScopes)"
            placement="bottom"
            :offset="30"
          >
            <div class="describe">
              {{ ChangeToString(list.businessScopes) }}
            </div>
          </el-tooltip>
        </div>
        <!-- <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow='false'
            :content='ChangeString(list)'
            placement="bottom"
            :offset='10'
          >
            <div style="display: inline">{{ChangeString(list)}}</div>
          </el-tooltip>
        </div> -->
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.contact"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ list.contact }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.phoneNumber"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ list.phoneNumber }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          {{ StatusData(list.teamStatus) }}
        </div>
        <!-- <div class="listDiv">{{SizeData(list.teamSize)}}</div> -->
        <div class="listDiv">{{ list.teamSize }}</div>
        <!-- <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow='false'
            :content='ChangeToString(list.businessScopes)'
            placement="bottom"
            :offset='30'
          >
            <div style="display: inline"> {{ChangeToString(list.businessScopes)}}</div>
          </el-tooltip>
        </div> -->
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="formatDateTime(list.createTime)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">
              {{ formatDateTime(list.createTime) }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <span class="editor" @click="editorTeam(list)">编辑</span>
          <span class="dele" @click="deleTeam(list.id)">删除</span>
        </div>
      </li>
    </ul>
    <!-- 服务中心 我的需求 操作-->
    <ul class="list demand" v-else-if="isType == 'demand'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li v-for="(list, index) in teamList" :key="index">
        <div class="listDiv" @click="goTeamDetailsSec(list.no)">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.projectName"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.projectName }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="ChangeString(list)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ ChangeString(list) }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.contact"
            placement="bottom"
            :offset="30"
          >
            <div style="display: inline">{{ list.contact }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.phone"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ list.phone }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="addressString(list)"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              {{ list.provinceName }}{{ list.cityName }}{{ list.areaName
              }}{{ list.address }}
            </div>
          </el-tooltip>
        </div>
        <!-- <div class="listDiv">{{SizeData(list.teamSize)}}</div> -->
        <!-- <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow='false'
            :content='ChangeToString(list.businessScopes)'
            placement="bottom"
            :offset='30'
          >
            <div style="display: inline"> {{ChangeToString(list.businessScopes)}}</div>
          </el-tooltip>
        </div> -->
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="formatDateTime(Number(list.createTime))"
            placement="bottom"
            :offset="30"
          >
            <div style="display: inline">
              {{ formatDateTime(Number(list.createTime)) }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <span class="editor" @click="editordemand(list)">编辑</span>
          <span class="dele" @click="deledemand(list.id)">删除</span>
        </div>
      </li>
    </ul>
    <!-- 服务中心 设备管理 操作-->
    <ul class="list equ" v-if="isType == 'equ'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li class="content-title" v-for="(list, index) in teamList" :key="index">
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.name"
            placement="bottom"
            :offset="30"
          >
            <div
              class="describe"
              style="    color: #0286df;cursor: pointer;"
              @click="GoDetails(list)"
            >
              {{ list.name }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.describe"
            placement="bottom"
            :offset="30"
          >
            <div class="describe">{{ list.describe }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.model"
            placement="bottom"
            :offset="30"
          >
            <div class="describe">{{ list.model }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv">
          <div class="ImgBox">
            <el-image
              style="width: 100px; height: 100px"
              :src="list.picture[0]"
              :preview-src-list="list.picture"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <span class="picText">共{{ list.picture.length }}张图片</span>
          </div>
        </div>

        <div class="listDiv">
          <!-- <div class="ImgBox">
            <el-image
              style="width: 100px; height: 100px"
              :src="list.picturePic[0]?list.picturePic[0]:null"
              :preview-src-list="list.picturePic"
            >
            </el-image>
            <span class="picText">共{{list.picturePic.length}}张图片</span>
          </div> -->
          <div class="ImgBox">
            <el-image
              v-if="list.picturePic && list.picturePic[0]"
              style="width: 100px; height: 100px"
              :src="
                list.picturePic && list.picturePic[0]
                  ? list.picturePic[0]
                  : null
              "
              :preview-src-list="list.picturePic"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <video
              v-if="
                !list.picturePic[0] && list.pictureVideo && list.pictureVideo[0]
              "
              style="width:100px;height:100px"
              :src="list.pictureVideo[0]"
              class="avatar"
              controls="controls"
            >
              您的浏览器不支持视频播放
            </video>
            <span class="picText" v-if="list.pictureTotal">
              共{{ list.pictureTotal ? list.pictureTotal : 0 }}条信息
            </span>
          </div>
        </div>

        <div class="listDiv">
          <span class="editor" @click="editor(list)">编辑</span>
          <span class="dele" @click="dele(list.id)">删除</span>
        </div>
      </li>
    </ul>
    <!-- 服务中心 自有设备 操作-->
    <ul class="list equList" v-if="isType == 'equList'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li class="content-title" v-for="(list, index) in teamList" :key="index">
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.name"
            placement="bottom"
            :offset="10"
          >
            <div class="describe" @click="GoDetails(list)">{{ list.name }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.describe"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              <span>
                {{ list.describe }}
              </span>
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.model"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.model }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv">
          <div class="ImgBox">
            <el-image
              style="width: 100px; height: 100px"
              :src="list.picture[0]"
              :preview-src-list="list.picture"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <span class="picText">共{{ list.picture.length }}张图片</span>
          </div>
        </div>

        <div class="listDiv">
          <div class="ImgBox">
            <el-image
              v-if="list.picturePic && list.picturePic[0]"
              style="width: 100px; height: 100px"
              :src="
                list.picturePic && list.picturePic[0]
                  ? list.picturePic[0]
                  : null
              "
              :preview-src-list="list.picturePic"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <video
              v-if="
                !list.picturePic[0] && list.pictureVideo && list.pictureVideo[0]
              "
              style="width:100px;height:100px"
              :src="list.pictureVideo[0]"
              class="avatar"
              controls="controls"
            >
              您的浏览器不支持视频播放
            </video>
            <span class="picText" v-if="list.pictureTotal">
              共{{ list.pictureTotal ? list.pictureTotal : 0 }}条信息
            </span>
          </div>
          <!-- <div class="ImgBox">
            <el-image
              style="width: 100px; height: 100px"
              :src="list.picturePic[0]?list.picturePic[0]:null"
              :preview-src-list="list.picturePic"
            >
            </el-image>
            <span class="picText">共{{list.picturePic.length}}张图片</span>
          </div> -->
        </div>

        <div class="listDiv">
          <span class="dele" @click="deleList(list.id)">删除</span>
        </div>
      </li>
    </ul>
    <!-- 服务中心 发布团队中 团队业绩 操作-->
    <ul class="list teamPerformance" v-else-if="isType == 'teamPerformance'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li v-for="(list, index) in teamList" :key="index + 'p'">
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.projectName"
            placement="bottom"
            :offset="1"
          >
            <!-- <div style="display: inline"> {{list.projectName?list.projectName:null}}</div> -->
            <div class="describe">
              {{ list.projectName ? list.projectName : null }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="addressStringOne(list)"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ addressStringOne(list) }}</div>
          </el-tooltip>
        </div>

        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.owner"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.owner }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="changPecTime(list.startTime, list.endTime)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">
              {{ timeToString(list.startTime) }}~{{
                timeToString(list.endTime)
              }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.projectDescribe"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.projectDescribe }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.construction"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">{{ list.construction }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <!-- <div class="ImgBox">
            <img
              src=""
              alt=""
            >
            <span class="picText">共3条信息</span>
          </div> -->
          <div class="ImgBox">
            <el-image
              v-if="list.picturePic && list.picturePic[0]"
              style="width: 100px; height: 100px"
              :src="
                list.picturePic && list.picturePic[0]
                  ? list.picturePic[0]
                  : null
              "
              :preview-src-list="list.picturePic"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <video
              v-if="
                !list.picturePic[0] && list.pictureVideo && list.pictureVideo[0]
              "
              style="width:100px;height:100px"
              :src="list.pictureVideo[0]"
              class="avatar"
              controls="controls"
            >
              您的浏览器不支持视频播放
            </video>
            <span class="picText" v-if="list.pictureTotal">
              共{{ list.pictureTotal ? list.pictureTotal : 0 }}条信息
            </span>
          </div>
        </div>
        <div class="listDiv">
          <span class="editor" @click="editorPer(list)">编辑</span>
          <span class="dele" @click="delePer(list.id)">删除</span>
        </div>
      </li>
    </ul>
    <!-- 服务中心 发布团队中 人员组成 操作-->
    <ul class="list teamPerson" v-else-if="isType == 'teamPerson'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li v-for="(list, index) in teamList" :key="index + 's'">
        <div class="listDiv">
          {{ list.name }}
        </div>
        <div class="listDiv">{{ list.age }}</div>
        <div class="listDiv">{{ list.workingYear }}</div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.position"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              <span>
                {{ list.position }}
              </span>
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.introduction"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              {{ list.introduction }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <div class="ImgBox" v-if="list.picture && list.picture[0]">
            <el-image
              style="width: 100px; height: 100px"
              fit="cover"
              :src="list.picture[0]"
              :preview-src-list="list.picture"
            >
              <div
                slot="placeholder"
                class="image-slot"
                style="textAlign: center;    background: #f5f7fa;"
              >
                加载中<span class="dot">...</span>
              </div>
            </el-image>
            <span class="picText">共{{ list.certificates.length }}条信息</span>
          </div>
        </div>
        <div class="listDiv">
          <span class="editor" @click="editorOwn(list)">编辑</span>
          <span class="dele" @click="deleOwn(list.id)">删除</span>
        </div>
      </li>
    </ul>

    <!-- 需求发布 找活干 施工报价 操作-->
    <ul class="list offer" v-else-if="isType == 'offer'">
      <li class="table-title">
        <div v-for="(item, index) in titleList" :key="index">{{ item }}</div>
      </li>
      <li v-for="(list, index) in teamList" :key="index + 'q'">
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="ChangeString(list)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ ChangeString(list) }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.unit"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline">{{ list.unit }}</div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.equipment"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              {{ list.equipment }}
            </div>
          </el-tooltip>
        </div>
        <div :class="['listDiv', list.priceStatus == 2 ? null : 'lhString']">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="ifData(list)"
            placement="bottom"
            :offset="10"
          >
            <div style="display: inline" v-if="list.priceStatus == 2">
              <div class="hasOne">包含辅材：{{ list.material }}</div>
              <div style="height:1px ;borderTop:1px dashed #f1f1f1"></div>
              <div>不含辅材</div>
            </div>
            <div style="display: inline" v-else-if="list.priceStatus == 1">
              <span>不含辅材</span>
            </div>
            <div class="hasOne" v-else-if="list.priceStatus == 0">
              <span>包含辅材：{{ list.material }}</span>
            </div>
          </el-tooltip>
        </div>
        <div :class="['listDiv', list.priceStatus == 2 ? null : 'lhString']">
          <div style="display: inline" v-if="list.priceStatus == 2">
            <div>{{ list.priceWithMaterial }}</div>
            <div style="height:1px ;borderTop:1px dashed #f1f1f1"></div>
            <div>{{ list.price }}</div>
          </div>
          <div style="display: inline" v-else-if="list.priceStatus == 1">
            <span>{{ list.price }}</span>
          </div>
          <div style="display: inline" v-else-if="list.priceStatus == 0">
            <span>{{ list.priceWithMaterial }}</span>
          </div>
        </div>
        <div class="listDiv">
          <el-tooltip
            popper-class="changeTootip"
            effect="light"
            :visible-arrow="false"
            :content="list.principle"
            placement="bottom"
            :offset="10"
          >
            <div class="describe">
              {{ list.principle }}
            </div>
          </el-tooltip>
        </div>
        <div class="listDiv">
          <span class="editor" @click="editorOffer(list)">编辑</span>
          <span class="dele" @click="deleOffer(list.id)">删除</span>
        </div>
      </li>
    </ul>
    <!-- 加载框-->
    <div class="loading" v-if="loadingTrue && isType == 'isShow'">
      <div class="icon">
        <i class="el-icon-loading"></i>
      </div>
      <p>数据加载中</p>
    </div>
    <!-- 加载框-->
    <div class="loading" v-if="loadingTrue">
      <div class="icon">
        <i class="el-icon-loading"></i>
      </div>
      <p>数据加载中</p>
    </div>
    <!-- 暂无数据-->
    <div
      class="noData"
      :class="isType == '2' ? 'equNoData' : ''"
      v-if="noTextData"
    >
      <div class="noDataImg">
        <img src="@/static/img/cailiao.png" alt />
      </div>
      <p class="noText">暂无数据</p>
    </div>
  </div>
</template>
<script>
import { formatDateTime } from "@/filters"
import sessionStorage from "@/storage/sessionStorage"
import { apiResignAll } from "@/api/apiResignAll"

export default {
  name: "LeaseList",
  components: {},
  props: {
    isborder: {
      type: Boolean,
      required: false,
      default: false
    },
    isType: {
      type: String,
      required: false
    },
    isShow: {
      type: Boolean,
      required: false
    },
    titleList: {
      type: Array,
      required: true
    },
    teamList: {
      type: Array,
      required: true
    },
    loadingTrue: {
      type: Boolean,
      required: true
    },
    noTextData: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      teamSizeOption: []
    }
  },
  computed: {},
  created() {
    this.getteamSizeOption()
  },
  methods: {
    // 跳转报价详情
    goDeatilPrise(list) {
      sessionStorage.save("PriseDetails", JSON.stringify(list))
      this.$router.push({ path: `/RedesignTeamDetailsPrise` })
    },
    // 跳转详情业绩
    goDeatilRes(list) {
      sessionStorage.save("resultsDetails", JSON.stringify(list))
      this.$router.push({ path: `/RedesignTeamDetailsReslut` })
    },
    // 跳转详情设备
    GoDetailsEqu(list) {
      sessionStorage.save("equipmentDetails", JSON.stringify(list))
      this.$router.push({ path: `/RedesignTeamDetailsEqu` })
    },
    // 获得团队规模
    async getteamSizeOption() {
      let res = await apiResignAll.getteamSizeOption()
      //
      //
      if (res && res.data && res.data.code === 200) {
        this.teamSizeOption = res.data.data
      }
    },
    // 工队报价详情
    goRentalDetailsPrice(list) {
      // this.$router.push({ path: `/volunteerTeamOfferDetails/${id}` });
      // sessionStorage.save("equNo", list.no);
      // sessionStorage.save("PriseDetails", JSON.stringify(list));
      this.$router.push({
        path: `/RedesignDetailsPrise/${list.teamNo}/${list.no}`
      })
    },
    formatDateTime,
    // 省市区
    addressStringOne(list) {
      return `${list.provinceName}${list.cityName}${list.projectPlace}`
    },
    // 省市区
    addressString(list) {
      return `${list.provinceName}${list.cityName}${list.areaName}${list.address}`
    },
    // 辅材
    ifData(list) {
      if (list.hasMaterial === 2) {
        return `包含辅材：${list.priceWithMaterial} 不含辅材: ${list.principle}`
      } else if (list.hasMaterial === 0) {
        return `包含辅材：${list.priceWithMaterial}`
      } else if (list.hasMaterial === 1) {
        return `不含辅材: ${list.principle}`
      }
    },

    // 时间显示
    changPecTime(a, b) {
      return this.timeToString(a) + "~" + this.timeToString(b)
    },

    // typeString分类
    ChangeString(data) {
      const stringF = data.firstCategoryName ? data.firstCategoryName : ""
      const stringS = data.secondCategoryName
        ? `/${data.secondCategoryName}`
        : ""
      const stringT = data.thirdCategoryName ? `/${data.thirdCategoryName}` : ""
      return `${stringF} ${stringS}${stringT} `
    },
    // 团队规模
    StatusData(data) {
      switch (data) {
        case 1:
          return "可出工"
        case 0:
          return "不可出工"
        default:
          break
      }
    },
    // 状态
    SizeData(data) {
      const obj = this.teamSizeOption.find(
        (value, index, array) => value.no === data
      )
      if (obj) {
        return obj.name
      }
      // switch (data) {
      //   case 1:
      //     return "10-30人";
      //     break;
      //   case 2:
      //     return "30-50人";
      //     break;
      //   case 3:
      //     return "50-80人";
      //     break;
      //   case 4:
      //     return "80-100人";
      //     break;
      //   case 5:
      //     return "100人以上";
      //     break;
      //   default:
      //     break;
      // }
    },
    // 业务范围
    ChangeToString(data) {
      if (data) {
        // const array = JSON.parse(data);
        const array = data
        const arrayIndex = []
        array.map(item => {
          const stringData = `${
            item.firstCategoryName ? item.firstCategoryName : ""
          }${item.secondCategoryName ? "/" + item.secondCategoryName : ""}
          ${item.thirdCategoryName ? "/" + item.thirdCategoryName : ""}`
          arrayIndex.push(stringData)
        })
        return arrayIndex.join(" ; ")
      } else {
        return null
      }
    },
    // 施工报价编辑
    editorOffer(item) {
      this.$emit("Offereditor", item)
    },
    // 施工报价删除
    deleOffer(id) {
      this.$emit("OfferDele", id)
    },

    // 需求编辑
    editordemand(item) {
      this.$emit("Demandeditor", item)
    },
    // 需求删除
    deledemand(id) {
      this.$emit("DemandDele", id)
    },
    // 团队编辑
    editorTeam(item) {
      this.$emit("Teameditor", item)
    },
    // 团队删除
    deleTeam(id) {
      this.$emit("TeamDele", id)
    },
    // 团队跳转详情
    goTeamDetails(id) {
      this.$router.push({ path: `/teamDetails/${id}` })
    },
    goTeamDetailsSec(id) {
      this.$router.push({ path: `/SecdemandDetails/${id}` })
    },
    // 时间格式转化
    timeToString(timestamp) {
      const d = new Date(timestamp * 1000) // 根据时间戳生成的时间对象
      const date =
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
      return date
    },
    // 人员编辑
    editorOwn(item) {
      this.$emit("Personeditor", item)
    },
    // 人员删除
    deleOwn(id) {
      this.$emit("PersonDele", id)
    },
    // 团队业绩编辑
    editorPer(item) {
      this.$emit("Performanceditor", item)
    },
    // 团队业绩删除
    delePer(id) {
      this.$emit("PerformanceDele", id)
    },
    // 跳转设备详情
    GoDetails(item) {
      const obj1 = {
        title: "当前位置：",
        fristName: "我的团队",
        fristPath: "/myTeam",
        secondName: "设备管理",
        secondPath: "/myTeam/equipment",
        icon: ">",
        threeName: "设备详情"
      }
      sessionStorage.save("routerKey", JSON.stringify(obj1))
      sessionStorage.save("equipmentDetails", JSON.stringify(item))
      this.$router.push({ path: `/myTeam/equipmentDetails` })
    },
    // 设备修改
    editor(item) {
      this.$emit("EEditor", item)
    },
    // 设备删除
    dele(id) {
      this.$emit("EDele", id)
    },
    // 设备列表删除
    deleList(id) {
      this.$emit("equListDele", id)
    },
    goRentalDetails(id) {
      this.$router.push({ path: `/teamDetails/${id}` })
    }
  },
  watch: {
    teamList(n, o) {
      if (this.isType === "equList") {
        n.map(item => {
          //
          if (typeof item.picture === "string") {
            item.picture = item.picture.split(",")
          }
        })
      }
      if (
        this.isType === "equ" ||
        this.isType === 2 ||
        this.isType === "equList"
      ) {
        //
        n.map(item => {
          //
          if (typeof item.picture === "string") {
            item.picture = item.picture.split(",")
          }
        })
        if (
          this.isType === "equ" ||
          this.isType === "equList" ||
          this.isType === "2"
        ) {
          n.map(item => {
            const array = []
            const arrayVideo = []
            if (item.evidences && item.evidences.length > 0) {
              item.evidences.map(idx => {
                if (idx.type === 1) {
                  // 图片
                  array.push(idx.url)
                } else if (idx.type === 2) {
                  // 视频
                  arrayVideo.push(idx.url)
                }
              })
            }

            item.picturePic = array
            item.pictureVideo = arrayVideo
            item.pictureTotal =
              Number(item.picturePic.length) + Number(item.pictureVideo.length)
          })
        }
      } else if (this.isType === "teamPerson" || this.isType === "1") {
        n.map(item => {
          const array = []
          if (item.certificates && item.certificates.length > 0) {
            item.certificates.map(idx => {
              array.push(idx.picture)
            })
          }
          item.picture = array
        })
      } else if (this.isType === "teamPerformance" || this.isType === "0") {
        n.map(item => {
          const array = []
          const arrayVideo = []
          if (item.evidences && item.evidences.length > 0) {
            item.evidences.map(idx => {
              if (idx.type === 1) {
                // 图片
                array.push(idx.url)
              } else if (idx.type === 2) {
                // 视频
                arrayVideo.push(idx.url)
              }
            })
          }
          item.picturePic = array
          item.pictureVideo = arrayVideo
          item.pictureTotal =
            Number(item.picturePic.length) + Number(item.pictureVideo.length)
        })
        //
        //
      }
    },
    isType(n, o) {
      //
      //
      //
    }
  },

  mounted() {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/static-style";
/* 面包屑 */
.LeaseList {
  // width: 1200px;
  margin: 0 auto;
  overflow: hidden;

  .loading {
    width: 100%;
    height: 80px;
    margin-bottom: 20px;
    margin-top: 100px;
    .icon {
      width: 48px;
      margin: 0 auto;

      i {
        font-size: 48px;
        color: #1890e1;
      }
    }

    p {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
  }

  ul.list {
    width: 100%;
    list-style-type: none;
    background: #ffffff;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.08);
    border: 1px solid #e4e7ed;
    box-sizing: border-box;
    border-radius: 0 0 4px 4px;

    .table-title {
      background-color: #fafafa;
      color: #000;
      font-weight: 500;
      font-size: 14px;
      text-align: left;

      > div {
        padding: 0 10px;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
      }
    }

    > li {
      width: 100%;
      height: 54px;
      line-height: 54px;
      box-sizing: border-box;
      border-bottom: 1px solid #e3e8ed;
      display: flex;
      text-align: left;
      position: relative;

      .posiIcon {
        padding: 0 !important;
        position: absolute;
        width: 24px;
        height: 28px;
        top: -5px;
        left: 10px;

        img {
          width: 100%;
          height: 100%;
        }
      }

      > div {
        padding: 0 10px;
        box-sizing: border-box;
        text-align: left;
        flex: 1;
        // &:nth-child(1) {
        //   width: 200px;
        //   padding-left: 20px;
        // }
        // &:nth-child(2) {
        //   width: 100px;
        // }
        // &:nth-child(3) {
        //   width: 100px;
        // }
        // &:nth-child(4) {
        //   width: 100px;
        // }
        // &:nth-child(5) {
        //   width: 120px;
        //   // color: #0286DF!important;
        // }
        // &:nth-child(6) {
        //   flex: 1;
        // }
        // &:nth-child(7) {
        //   flex: 1;
        // }
        // &:nth-child(8) {
        //   flex: 1;
        // }
        // &:nth-child(9) {
        //   flex: 1;
        // }
        // &:nth-child(10) {
        //   width: 100px;
        // }
        .examine {
          position: absolute;
          top: 12px;
          width: 100px;
          height: 35px;
          line-height: 35px;
          background: #ff542e;
          color: #ffffff;
          border-radius: 35px;
          cursor: pointer;
        }
      }

      div.listDiv {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }

    // > li:first-of-type {
    //   > div {
    //     font-size: 14px;
    //     font-family: MicrosoftYaHei;
    //     font-weight: 400;
    //     color: rgba(51, 51, 51, 1);
    //     font-weight: bold;
    //   }
    // }
    // > li:last-of-type {
    //   border: none;
    // }
    // > li:not(:first-of-type):hover {
    //   background: #f5f7fa;
    // }
  }

  .noData {
    width: 100%;
    margin-bottom: 50px;
    background: #ffffff;
    padding-bottom: 50px;
    padding-top: 50px;
    // border: 1px solid #e4e7ed;
    border-top: none;
    border-radius: 0 0 4px 4px;
    // border-top: none;
    box-sizing: border-box;

    .noDataImg {
      width: 177px;
      margin: 0 auto 15px;

      img {
        width: 100%;
      }
    }

    .noText {
      text-align: center;
      font-size: 18px;
      color: #333;
    }
  }

  .my {
    border: none !important;

    .table-title {
      // border-bottom: none;
      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          // width: 80px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(3) {
          flex: inherit;
          width: 80px;
        }
        &:nth-child(5) {
          flex: inherit !important;
          width: 80px !important;
        }
        &:nth-child(6) {
          flex: inherit !important;
          width: 110px !important;
        }
        &:nth-child(7) {
          flex: inherit !important;
          width: 150px !important;
        }
      }
    }

    > li {
      .listDiv {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:nth-child(1) {
          width: 80px;
          border-left: 1px solid rgba(228, 231, 237, 1);
          color: #0286df;
          text-decoration: underline;
          cursor: pointer;
        }
        &:nth-child(2) {
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(3) {
          flex: inherit;
          width: 80px;
        }
        &:nth-child(5) {
          flex: inherit;
          width: 80px;
        }
        &:nth-child(6) {
          flex: inherit !important;
          width: 110px !important;
        }
        &:nth-child(7) {
          flex: inherit !important;
          width: 150px !important;
        }
        &:nth-child(8) {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }
      }
    }
  }

  .demand {
    border: none !important;

    .table-title {
      // border-bottom: none;
      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          // width: 80px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
      }
    }

    > li {
      .listDiv {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:nth-child(1) {
          width: 80px;
          border-left: 1px solid rgba(228, 231, 237, 1);
          color: #0286df;
          text-decoration: underline;
          cursor: pointer;

          display: flex;
          align-items: center;
          justify-content: center;

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #0286df;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(5) {
          display: flex;
          align-items: center;
          justify-content: center;

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }

        &:nth-child(7) {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }
      }
    }
  }

  .equ {
    border: none !important;

    .table-title {
      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          // width: 80px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
      }
    }

    .content-title {
      height: 120px;

      .listDiv {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          // cursor: pointer;
          // width: 100px;
          // line-height: 15px;
          // color: #0286df !important;
          border-left: 1px solid rgba(228, 231, 237, 1);

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(2) {
          // padding: 10px 0;
          // width: 270px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(3) {
          // padding: 10px 0;
          // width: 270px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(4) {
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 100px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 27px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(5) {
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 100px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 27px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(6) {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }
      }
    }
  }

  .equList {
    border: none !important;

    .table-title {
      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          // width: 80px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
      }
    }

    .content-title {
      height: 120px;

      .listDiv {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          cursor: pointer;
          // padding: 20px;
          width: 100px;
          line-height: 15px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(2) {
          // padding: 10px 0;
          // width: 270px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(3) {
          // padding: 10px 0;
          // width: 270px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }
        &:nth-child(4) {
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 100px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 27px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(5) {
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 100px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 27px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(6) {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }
      }
    }
  }

  .offer {
    border: none !important;

    .table-title {
      height: 53px !important;

      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          width: 140px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(3) {
          width: 50px;
          flex: auto;
        }
        &:nth-child(4) {
          width: 80px;
          flex: auto;
        }
        &:nth-child(5) {
          width: 25px;
          flex: auto;
        }
        &:nth-child(6) {
          width: 50px;
          flex: auto;
        }
      }
    }

    > li {
      height: 55px !important;

      .listDiv {
        height: 55px !important;
        line-height: 55px;
        text-align: left;
        // line-height: 20px;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &:nth-child(1) {
          width: 140px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(3) {
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(4) {
          width: 80px;
          flex: auto;
          line-height: 27px;
          .hasOne {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            // line-height: 24px;
          }
        }
        &:nth-child(5) {
          width: 25px;
          flex: auto;
          line-height: 27px;
        }
        &:nth-child(6) {
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }

        &:nth-child(7) {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }

        &.lhString {
          line-height: 55px;
        }
      }
    }
  }

  .teamPerformance {
    border: none !important;

    .table-title {
      height: 53px !important;

      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);
        flex: 1;

        &:nth-child(1) {
          width: 300px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
      }
    }

    > li {
      height: 120px !important;

      .listDiv {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        // flex: 1;
        line-height: 120px;
        height: 120px;

        // border-right: 1px solid rgba(228, 231, 237, 1);
        &:nth-child(1) {
          width: 100px;
          border-left: 1px solid rgba(228, 231, 237, 1);
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }

        &:nth-child(2) {
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(3) {
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(5) {
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(6) {
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(7) {
          position: relative;

          .ImgBox {
            margin-top: 10px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 97px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 10px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(8) {
          width: 60px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }
      }
    }
  }

  .teamPerson {
    border: none !important;

    .table-title {
      height: 53px !important;

      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          width: 30px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(2) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(3) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(4) {
          width: 40px;
          flex: auto;
        }
        &:nth-child(5) {
          width: 300px;
          // width: 80px;
          flex: auto;
        }
        &:nth-child(6) {
          width: 60px;
          flex: auto;
        }
      }
    }

    > li {
      height: 120px !important;

      .listDiv {
        height: 120px;
        text-align: left;
        // line-height: 20px;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 120px;
        // display: flex;
        // justify-content: flex-start;
        // align-items: center;
        &:nth-child(1) {
          width: 30px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(2) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(3) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(4) {
          width: 40px;
          flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(5) {
          width: 300px;
          // width: 80px;
          flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            width: 300px;
            // height: 60px;
            line-height: 24px;
            line-height: 20px;
            word-break: break-all;
            float: left !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            white-space: normal !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }

        &:nth-child(6) {
          width: 60px;
          flex: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 97px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 13px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(7) {
          display: flex;
          align-items: center;
          justify-content: flex-start;

          .editor {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(2, 134, 223, 1);
            margin-right: 20px;
            cursor: pointer;
          }

          .dele {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 102, 0, 1);
            cursor: pointer;
          }
        }
      }
    }
  }

  .resultsDetails {
    border: none !important;

    .table-title {
      height: 53px !important;

      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);
        flex: 1;

        &:nth-child(1) {
          width: 300px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
      }
    }

    > li {
      height: 120px !important;

      .listDiv {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        // flex: 1;
        line-height: 120px;
        height: 120px;

        &:nth-child(1) {
          // width: 100px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-left: 1px solid rgba(228, 231, 237, 1);
          .describe {
            width: 100px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(2) {
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(3) {
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(5) {
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(6) {
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(7) {
          position: relative;

          .ImgBox {
            margin-top: 10px;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 97px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 10px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }

  .resultsDetailsPerson {
    border: none !important;

    .table-title {
      height: 53px !important;

      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);
        flex: 1;

        &:nth-child(1) {
          width: 30px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(2) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(3) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(4) {
          width: 40px;
          flex: auto;
        }
        &:nth-child(5) {
          width: 280px;
          flex: auto;
        }
        &:nth-child(6) {
          width: 60px;
          flex: auto;
        }
      }
    }

    > li {
      height: 120px !important;

      .listDiv {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        // flex: 1;
        height: 120px;
        line-height: 120px;

        &:nth-child(1) {
          width: 30px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(2) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(3) {
          width: 20px;
          flex: auto;
        }
        &:nth-child(4) {
          width: 40px;
          flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(5) {
          width: 280px;
          // width: 80px;
          flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            width: 300px;
            // height: 60px;
            line-height: 24px;
            line-height: 20px;
            word-break: break-all;
            float: left !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
            white-space: normal !important;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
        }

        &:nth-child(6) {
          width: 60px;
          flex: auto;
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 97px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 15px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }

  .resultsDetailsEqu {
    border: none !important;

    .table-title {
      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);
        flex: 1;

        &:nth-child(1) {
          width: 300px;
          // flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
      }
    }

    .content-title {
      height: 120px;
      // border: 1px solid rgba(228, 231, 237, 1);
      .listDiv {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: left;
        line-height: 20px;
        border-right: 1px solid rgba(228, 231, 237, 1);

        &:nth-child(1) {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);
          border-left: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(2) {
          // padding: 10px 0;
          // width: 270px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(3) {
          // padding: 10px 0;
          // width: 270px;
          // flex: auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }

        &:nth-child(4) {
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 100px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 34px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }

        &:nth-child(5) {
          position: relative;

          .ImgBox {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;

            .picText {
              width: 100px;
              text-align: center;
              display: inline-block;
              height: 20px;
              position: absolute;
              left: 34px;
              bottom: 10px;
              background: rgba(0, 0, 0, 1);
              opacity: 0.5;
              line-height: 12px;
              font-size: 12px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(255, 255, 255, 1);
              line-height: 20px;
            }

            img {
              display: inline-block;
              width: 100px;
              height: 100px;
            }
          }
        }
      }
    }
  }

  .resultsDetailsOffer {
    border: none !important;

    .table-title {
      height: 53px !important;

      > div {
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        border-top: 1px solid rgba(228, 231, 237, 1);
        flex: 1;
        &:nth-child(1) {
          width: 50px;
          flex: auto;
          border-left: 1px solid rgba(228, 231, 237, 1);
        }
        &:nth-child(2) {
          width: 50px;
          flex: auto;
        }
        &:nth-child(3) {
          width: 50px;
          flex: auto;
        }
        &:nth-child(4) {
          width: 50px;
          flex: auto;
        }
        &:nth-child(5) {
          width: 40px;
          flex: auto;
        }
        &:nth-child(6) {
          width: 50px;
          flex: auto;
        }
        &:nth-child(7) {
          width: 70px;
          flex: auto;
        }
        &:nth-child(8) {
          width: 50px;
          flex: auto;
        }
        &:nth-child(9) {
          width: 50px;
          flex: auto;
        }
      }
    }

    > li {
      height: 55px !important;

      .listDiv {
        height: 55px !important;
        line-height: 55px;
        text-align: left;
        border-right: 1px solid rgba(228, 231, 237, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;

        &:nth-child(1) {
          border-left: 1px solid rgba(228, 231, 237, 1);
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(2) {
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(3) {
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(4) {
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }
        &:nth-child(5) {
          width: 40px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            line-height: 24px;
          }
        }

        &:nth-child(6) {
          width: 50px;
          flex: auto;
          line-height: 27px;
          .hasOne {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        &:nth-child(7) {
          width: 70px;
          flex: auto;
          line-height: 27px;
          .hasOne {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
        &:nth-child(8) {
          width: 50px;
          flex: auto;

          display: flex;
          align-items: center;
          justify-content: center;
          border-right: 1px solid rgba(228, 231, 237, 1);

          .describe {
            width: 135px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);

            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            line-height: 24px;
          }
        }
        &:nth-child(9) {
          width: 50px;
          flex: auto;
        }
        &.lhString {
          line-height: 55px !important;
        }
      }
    }
  }

  .equNoData {
    // border: 1px solid #e4e7ed;
  }
}

.colorOrange {
  color: #ff542e !important;
}

.tc_5 {
  height: 5px;
}

.resultsDetailsOfferlist {
  border: 1px solid rgba(228, 231, 237, 1);
  font-size: 14px;

  & > li {
    display: flex;
    height: 60px !important;
    line-height: 60px !important;
    border-bottom: 1px solid rgba(228, 231, 237, 1);

    &:last-child {
      border-bottom: none;
    }

    & > div {
      padding: 0 10px;
      box-sizing: border-box;
    }

    .table-title {
      background: #fafafa;
      font-weight: 700;
      color: #333;
    }

    .listDiv {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      color: #666666;
      &.lhString {
        & > .hasOne {
          line-height: 60px !important;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }

        & > .hasTwo {
          width: 100%;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          line-height: 30px !important;

          .hasLine {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            border-bottom: 1px dashed rgba(228, 231, 237, 1);
          }
        }
      }
    }

    & > div:nth-child(1) {
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // border-right: 1px solid rgba(228, 231, 237, 1);

      .describe {
        width: 130px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 24px;
      }
    }

    & > div:nth-child(2) {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .describe {
        width: 130px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 24px;
      }
    }
    & > div:nth-child(3) {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .describe {
        width: 130px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 24px;
      }
    }
    & > div:nth-child(4) {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      .describe {
        width: 130px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 24px;
      }
    }

    & > div:nth-child(5) {
      width: 100px;
      width: 140px;
    }

    & > div:nth-child(6) {
      width: 150px;
      width: 230px;
      .hasLine {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    & > div:nth-child(7) {
      width: 210px;
      width: 110px;
      .hasLine {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }

    & > div:nth-child(8) {
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // border-right: 1px solid rgba(228, 231, 237, 1);

      .describe {
        width: 135px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 24px;
      }
    }
    & > div:nth-child(9) {
      width: 140px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      // border-right: 1px solid rgba(228, 231, 237, 1);

      .describe {
        width: 135px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 24px;
      }
    }
  }
}
.noBorder {
  border: none !important;
}
</style>
<style lang="scss" rel="stylesheet/scss">
.changeTootip {
  max-width: 400px;
  border: 1px solid #767676 !important;
  padding: 4px !important;
  font-size: 12px !important;
  font-family: Microsoft YaHei;
  // font-weight: 300 !important;
  color: rgba(102, 102, 102, 1) !important;
  border-radius: 2px !important;
  max-width: 1200px !important;
}

.personTable {
  .el-upload-list__item {
    transition: none !important;
  }
}
</style>
